import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.button.attrs({
  type: 'button',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  height: ${props => props.tamanho};
  width: ${props => props.size};
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;
  cursor: ${props => (props.dis ? 'not-allowed' : 'pointer')};
  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;

const loadingAnimation = keyframes`
  0%, 100% {
    transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
  }
}`;

export const Loading = styled.span`
  width: 20px;
  height: 20px;
  position: relative;
  &::before,
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.3;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${loadingAnimation} 2s infinite ease-in-out;
  }
  &::after {
    animation-delay: -1s;
  }
`;
